// Base
import { BaseApi } from '../base.api'

// Interface
import {
  ICertificationWebpageApi,
  ICertificationWebpageApiRequest,
  ICertificationWebpageApiResponse,
  ICertificationWebpageApiGetAttrs,
  ICertificationWebpageApiDetailResponse,
  ICertificationWebpageApiGetDetailAttrs,
  ICertificationWebpageApiDownloadDocumentAttrs,
  ICertificationWebpageApiDownloadDocumentResponse,
  ICertificationWebpageApiClaimAttrs,
  ICertificationWebpageApiClaimResponse,
  ICertificationWebpageApiCancelAttrs,
  ICertificationWebpageApiNullResponse,
} from 'interfaces/webpage/certification/certification-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'
import { commonUtils_delay } from 'utils/common/common.utils'

export class CertificationWebpageApi extends BaseApi<ICertificationWebpageApi> implements ICertificationWebpageApiRequest {
  readonly url = ApiConstantHc.CERTIFICATION_URL
  private certificationUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get certification webpage
   *
   * @method POST
   * @access public
   *
   * @param {ICertificationWebpageApiGetAttrs} payload
   *
   * @return {Promise<ICertificationWebpageApiResponse>} Promise<ICertificationWebpageApiResponse>
   */
  async certificationWebpage_getCertification(
    payload: ICertificationWebpageApiGetAttrs,
  ): Promise<ICertificationWebpageApiResponse> {
    return this.POST(this.certificationUrl, {}, { ...payload.requestConfig })
  }

  /**
   * @description Get certification webpage detail
   *
   * @method POST
   * @access public
   *
   * @param {ICertificationWebpageApiGetDetailAttrs} payload
   *
   * @return {Promise<ICertificationWebpageApiDetailResponse>} Promise<ICertificationWebpageApiDetailResponse>
   */
  async certificationWebpage_getDetail(
    payload: ICertificationWebpageApiGetDetailAttrs,
  ): Promise<ICertificationWebpageApiDetailResponse> {
    return this.POST(`${this.certificationUrl}/${payload.params.certificationId}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Claim certification
   *
   * @method POST
   * @access public
   *
   * @param {ICertificationWebpageApiClaimAttrs} payload
   *
   * @return {Promise<ICertificationWebpageApiClaimResponse>} Promise<ICertificationWebpageApiClaimResponse>
   */
  async certificationWebpage_claim(payload: ICertificationWebpageApiClaimAttrs): Promise<ICertificationWebpageApiClaimResponse> {
    return this.POST(`${this.certificationUrl}/claim/${payload.params.certificationId}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Cancel certification
   *
   * @method POST
   * @access public
   *
   * @param {ICertificationWebpageApiCancelAttrs} payload
   *
   * @return {Promise<ICertificationWebpageApiNullResponse>} Promise<ICertificationWebpageApiNullResponse>
   */
  async certificationWebpage_cancel(payload: ICertificationWebpageApiCancelAttrs): Promise<ICertificationWebpageApiNullResponse> {
    return this.POST(`${this.certificationUrl}/cancel/${payload.params.assessmentId}`, {}, { ...payload.requestConfig })
  }

  /**
   * @description Download document
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ICertificationWebpageApiDownloadDocumentAttrs} payload
   *
   * @return {Promise<ICertificationWebpageApiDownloadDocumentResponse>} Promise<ICertificationWebpageApiDownloadDocumentResponse>
   */
  async certificationWebpage_downloadDocument(
    payload: ICertificationWebpageApiDownloadDocumentAttrs,
  ): Promise<ICertificationWebpageApiDownloadDocumentResponse> {
    try {
      // const response: ICertificationWebpageApiResponse = await this.POST(this.certificationUrl, {}, { ...payload.requestConfig })

      await commonUtils_delay(300)

      return Promise.resolve(true) as any
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
